import { motion } from "framer-motion";
import ScrollReveal from "./ScrollReveal";

const chapters = [
  {
    n: "I",
    label: "The Formulation",
    body:
      "Slow-pressed shea, cold-pressed jojoba, squalane, and mineral pigment. We work with a small material list, refined patiently, and revised only when improvement is measurable.",
  },
  {
    n: "II",
    label: "The Object",
    body:
      "Weighted glass. Anodised aluminium. A matte-lithographed carton in warm bone. The object is designed to sit on the vanity for a decade, not a season.",
  },
  {
    n: "III",
    label: "The Ritual",
    body:
      "A private gesture, performed slowly. Warm the balm between the fingertips. Press, do not draw. Wait a moment. Then, if you wish, close with a colour.",
  },
  {
    n: "IV",
    label: "The House",
    body:
      "The house was founded on a single principle — the discipline of leaving out. What follows the lip is already in the studio. Fragrance. Hand. Body. Home.",
  },
];

export default function ManifestoChapters() {
  return (
    <section className="relative py-32 md:py-44 border-t border-ink/15">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-4">
            <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-8">The Manifesto</p>
            <h2 className="font-serif-display text-5xl md:text-7xl leading-[0.95] max-w-[9ch]">
              Four <span className="italic font-serif-italic">quiet</span> principles.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8">
            <ol className="space-y-16 md:space-y-24">
              {chapters.map((c, i) => (
                <ScrollReveal key={c.n} delay={i * 0.05}>
                  <li className="grid grid-cols-12 gap-6 pt-10 border-t border-ink/25 first:border-t-0 first:pt-0">
                    <div className="col-span-3 md:col-span-2">
                      <div className="chapter-num text-[14vw] md:text-[7vw] leading-none text-plum">{c.n}</div>
                    </div>
                    <div className="col-span-9 md:col-span-10 md:pl-8">
                      <p className="text-[10px] uppercase tracking-editorial text-ink/60 mb-3">{`Chapter 0${i+1}`}</p>
                      <h3 className="font-serif-display text-3xl md:text-5xl leading-[1.02] mb-6">{c.label}</h3>
                      <p className="text-[16px] md:text-[18px] leading-[1.55] text-ink/80 max-w-[52ch]">{c.body}</p>
                    </div>
                  </li>
                </ScrollReveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
